import { Tag, TagProps } from "@carbon/react";
import React from "react";

import { useGetCaseAlertStatusLabel } from "src/hooks/alerts/useGetCaseAlertStatusLabel";
import { CaseAlertStatus } from "src/types/case";

const CASE_ALERT_STATUS_COLORS: { [key in CaseAlertStatus]: TagProps<"div">["type"] } = {
  initial: "gray",
  scored: "gray",
  compliant: "green",
  fraudPrevented: "blue",
  pendingDecision: "blue",
  provenFraudWithFinancialLoss: "red",
  provenFraudWithNoFinancialLoss: "red",
};

export const CaseAlertStatusTag: React.FC<{ status: CaseAlertStatus }> = ({ status }) => {
  const getCaseAlertStatusLabel = useGetCaseAlertStatusLabel();
  return (
    <Tag className="![max-inline-size:max-content]" type={CASE_ALERT_STATUS_COLORS[status]}>
      {getCaseAlertStatusLabel(status)}
    </Tag>
  );
};
